// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__o5DEq","footer_container":"Footer_footer_container__9dPz9","p":"Footer_p__C3Rzq"};